import { render, staticRenderFns } from "./my_message.vue?vue&type=template&id=4682ee65&scoped=true"
import script from "./my_message.vue?vue&type=script&lang=js"
export * from "./my_message.vue?vue&type=script&lang=js"
import style0 from "./my_message.vue?vue&type=style&index=0&id=4682ee65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4682ee65",
  null
  
)

export default component.exports